import { render, staticRenderFns } from "./dryjanuarywineinvestment.vue?vue&type=template&id=402cc6c2&scoped=true"
import script from "./dryjanuarywineinvestment.vue?vue&type=script&lang=js"
export * from "./dryjanuarywineinvestment.vue?vue&type=script&lang=js"
import style0 from "./dryjanuarywineinvestment.vue?vue&type=style&index=0&id=402cc6c2&prod&scoped=true&lang=css"
import style1 from "./dryjanuarywineinvestment.vue?vue&type=style&index=1&id=402cc6c2&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402cc6c2",
  null
  
)

export default component.exports